import IComponent from "components/commons/IComponent";

import Checkbox from "@material-ui/core/Checkbox";
import LayerToggleUtil from "utils/LayerToggleUtil";
import "./SlopeGroupCard.scoped.css";
import GetArcGISToken from "utils/GetArcGISToken";
import geometryTools from "utils/geometryTools";
import ItemCard from "./ItemCard";
import Extent from "@arcgis/core/geometry/Extent";
import MiniPanel from "components/commons/MiniPanel";
import ShowOperationBox from "./ShowOperationBox";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Button from "@material-ui/core/Button";

class SlopeGroupCard extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      showOperationBox: false,
    };
  }
  componentDidMount() {
    if (this.props.zoomNow) {
      this.zoom();
    }
  }
  componentWillUnmount() {}
  handleClickThreePoints(index) {
    this.setState({
      menuRowIndex: index,
      showOperationBox: !this.state.showOperationBox,
    });
  }
  onLeaveOperationContainer() {
    this.setState({
      showOperationBox: false,
    });
  }

  onCheckboxClick(layerItem, categry) {
    let isLayerLoaded = "layer" in layerItem && layerItem?.layer?.visible;
    let categoryItemInConfig = this.$config.mapList.layer3D[categry];
    if (categoryItemInConfig !== undefined) {
      let layerItemInConfig = categoryItemInConfig.find(
        (item) => item.id === layerItem.id
      );
      console.log("Itemcard layerItem", layerItem, categry);
      LayerToggleUtil.toggle3DLayer(
        categry,
        layerItem,
        !isLayerLoaded,
        this.props.mapView,
        false,
        !isLayerLoaded
      );

      this.setState({});
      this.props.on3DLayerChange();
    }
  }

  renderItemTableMode() {
    // let { layerItem } = this.props;

    return (
      <table className="layer3DResultTableMode">
        <thead>
          <td>&nbsp;</td>
          <td>Title</td>
          <td>Categry</td>
          <td>Create Date</td>
          <td />
          {/* <td>Transparency</td> */}
        </thead>
        <tbody>
          {this.props.itemsArrOfEachSlope.map((item, index) => {
            let currentItemCategory = null;
            if (this.props.generalResultCategoryMap !== null) {
              currentItemCategory = this.props.generalResultCategoryMap[index];
            } else {
              currentItemCategory = this.props.categry;
            }
            return (
              <tr height="100%">
                <td>
                  <div className="layer3DItemCheckbox">
                    <Checkbox
                      checked={"layer" in item && !!item?.layer?.visible}
                      onClick={this.onCheckboxClick.bind(
                        this,
                        item,
                        currentItemCategory
                      )}
                      color="primary"
                    />
                  </div>
                </td>
                <td>{item.title}</td>
                <td>{currentItemCategory}</td>
                <td>{item.createDate}</td>
                <td>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={this.handleClickThreePoints.bind(this, index)}
                  >
                    <MoreVertIcon fontSize="small" />
                  </div>
                  {this.state.showOperationBox &&
                    index === this.state.menuRowIndex && (
                      <div
                        onMouseLeave={() =>
                          this.setState({
                            showOperationBox: false,
                          })
                        }
                      >
                        <ShowOperationBox
                          showDialog={this.props.showDialog}
                          layerItem={item}
                        />
                      </div>
                    )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
  renderItemCards() {
    return this.props.itemsArrOfEachSlope.map((item, index) => {
      let currentItemCategory = null;
      if (this.props.generalResultCategoryMap !== null) {
        currentItemCategory = this.props.generalResultCategoryMap[index];
      } else {
        currentItemCategory = this.props.categry;
      }
      return (
        <ItemCard
          showDialog={this.props.showDialog}
          mapView={this.props.mapView}
          layerItem={item}
          categry={currentItemCategory}
          on3DLayerChange={() => this.props.on3DLayerChange()}
        />
      );
    });
  }

  async zoom() {
    let model = this.props.itemsArrOfEachSlope[0];
    let vm = this;
    if (model && model.extent && model.type !== "voxel") {
      let newCam = vm.props.mapView.camera.clone();
      newCam.tilt = 45;
      await this.props.mapView.goTo(newCam, { animate: false });
      await this.props.mapView.goTo(new Extent(model.extent), {
        animate: false,
      });
    } else if (model && model.extent && model.type === "voxel") {
      let activeExtent = model.extent;
      activeExtent.spatialReference = new geometryTools.SpatialReference({
        wkid: 102140,
        latestWkid: 2326,
      });
      activeExtent.zmin = -30;
      let extentBuffer = 1000;
      Object.keys(activeExtent).forEach((key) => {
        if (["xmax", "ymax"].includes(key)) {
          activeExtent[key] += extentBuffer;
        }
        if (["xmin", "ymin"].includes(key)) {
          activeExtent[key] -= extentBuffer;
        }
      });
      vm.props.mapView.goTo(activeExtent).catch((err) => {
        console.warn(err);
      });
    }
  }

  render() {
    return (
      //
      <div className="SlopeGroupCardContainer">
        <MiniPanel
          titleClass="ListTitle"
          darkMode={true}
          titleText={
            <div>
              <span
                className="icn_zoomtolayer"
                style={{ filter: "brightness(300%)", cursor: "pointer" }}
                onClick={this.zoom.bind(this)}
              />
              <span>&nbsp;</span>
              <span>{this.props.slopeName}</span>
            </div>
          }
        >
          <div className="itemCardsContainer">
            {this.props.cardMode === "card"
              ? this.renderItemCards()
              : this.renderItemTableMode()}
          </div>
        </MiniPanel>
      </div>
      //
    );
  }
}

export default SlopeGroupCard;
